"use strict";

function loadGoogleMapsScript() {
  return new Promise(function (resolve, reject) {
    // Check if the script is already included
    if (document.querySelector('script[src*="maps.googleapis.com"]')) {
      resolve(); // Script already loaded
      return;
    }
    var script = document.createElement('script');
    script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAv_4cMahi5arUcMemEBKpvkzI15r0ehRg&callback=evnentsMapInitialize&loading=async";
    script.async = true;
    script.defer = true;
    script.onerror = reject;
    script.onload = resolve;
    document.head.appendChild(script);
  });
}

// Call this function before initializing the map
loadGoogleMapsScript().then(function () {
  // The script has loaded, and the callback will be called automatically
})["catch"](function (error) {
  console.error("Error loading Google Maps script:", error);
});
function evnentsMapInitialize() {
  var map;
  var bounds = new google.maps.LatLngBounds();
  var mapCenter = {
    lat: 42.3681861,
    lng: -100.273816
  };
  var mapZoom = window.innerWidth <= 768 ? 2.6 : 4.2;
  var initialCenter = {
    lat: mapCenter.lat,
    lng: mapCenter.lng
  };
  var initialZoom = mapZoom;
  var map = new google.maps.Map(document.getElementById(map_id), {
    zoom: mapZoom,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    center: mapCenter,
    gestureHandling: 'greedy',
    scrollwheel: false,
    styles: [{
      elementType: 'geometry',
      stylers: [{
        color: '#085D71'
      }]
    }, {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [{
        color: '#085D71'
      }]
    }, {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [{
        color: '#085D71'
      }]
    }, {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{
        color: '#085D71'
      }]
    }, {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{
        color: '#085D71'
      }]
    }, {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{
        color: '#085D71'
      }]
    }, {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{
        color: '#ffffff'
      }]
    }, {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [{
        color: '#ffffff'
      }]
    }, {
      elementType: 'labels',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'administrative.country',
      elementType: 'geometry.stroke',
      stylers: [{
        color: '#ffffff'
      }, {
        weight: 2
      }]
    }]
  });
  var pinScaled = new google.maps.Size(20, 30);
  var pinAnchor = new google.maps.Point(10, 30);
  var activeImage = {
    url: map_icon.active,
    scaledSize: pinScaled,
    anchor: pinAnchor
  };
  var completedImage = {
    url: map_icon.completed,
    scaledSize: pinScaled,
    anchor: pinAnchor
  };
  // Display multiple markers on a map
  var infoWindow = new google.maps.InfoWindow(),
    marker,
    i;
  var allMarkers = [];
  // Loop through our array of markers & place each one on the map  
  for (i = 0; i < locations.length; i++) {
    var position = new google.maps.LatLng(locations[i].latitude, locations[i].longitude);
    bounds.extend(position);
    marker = new google.maps.Marker({
      position: position,
      map: map,
      title: locations[i].title,
      icon: locations[i].icon === 'completed' ? completedImage : activeImage,
      zIndex: locations[i].icon === 'active' ? 1 : 0
    });
    allMarkers.push(marker);
    // Allow each marker to have an info window   
    google.maps.event.addListener(marker, 'click', function (marker, i) {
      return function () {
        var html = '<div class="projects-map-block__dialog">';
        html += '<h3><strong>' + locations[i].title + '</strong></h3>';
        // html += '<p>' + locations[i].address + '</p>';
        html += '<div class="btn-wrapper"><a class="btn" href="' + locations[i].url + '">View Project</a></div>';
        html += '</div>';
        infoWindow.setContent(html);
        infoWindow.open(map, marker);
        // Center the map on the marker and zoom in
        map.setCenter(marker.getPosition());
        map.setZoom(10); // Adjust zoom level as needed
      };
    }(marker, i));
  }
  var resetBtn = typeof map_reset_button_id !== 'undefined' && map_reset_button_id ? document.getElementById(map_reset_button_id) : null;
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      infoWindow.close();
      map.setCenter(initialCenter);
      map.setZoom(initialZoom);
    });
  }
}